var _ = require('underscore');
module.exports = function(options){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
__p+='';

  let {
    attribution
  } = options;

__p+='\n\n<div class="article-attribution">\n    ';
 if (attribution.entity === 'sponsor') { 
__p+='\n    <span class="article-attribution-powered-by-text margin-right-sm">Sponsored by</span>\n    ';
 } 
__p+='\n    <a href="'+
((__t=( attribution.sponsor_url))==null?'':__t)+
'"><span\n        class="article-attribution-name">'+
((__t=( attribution.sponsored_name && attribution.sponsor_name.to_s.gsub(/#{SPONOSORED_LOGO_TXT}/i, '').strip ))==null?'':__t)+
'</span></a>\n</div> <!-- article-attribution -->\n';
return __p;
};



// WEBPACK FOOTER //
// ./templates/news_advice_article_attribution.jst.ejs